import { Configurator } from '../configurator';
import { entityDecode } from '@api/utils';
import { CoPaymentState } from '../configurator/CoPaymentState';

declare global {
    interface Window {
        VF: any;
    }
}

export async function getOOrder (tariff?, product?, offer?, kiasCode?, amount?) {
    if (!offer) {
        tariff = (Configurator.getSubTariff() && Configurator.getCoPaymentState() === CoPaymentState.TOGGLE_ON ? Configurator.getSubTariff() : Configurator.getTariff());
        product = Configurator.getProduct();
        offer = Configurator.getOffer();
        kiasCode = tariff.getKIASCode();
        amount = Configurator.getAmount();
    }

    const oOrder = {
        aPropositions: [],
        aProducts: []
    };

    const productCategory = product ? 'bundle' : 'tariff';

    let productLine = tariff.subscriptionType;

    if (productLine === 'voicedata') {
        productLine = 'voice';
    }

    const aPropositions = {
        id: 1,
        name: entityDecode(offer.getLabel()),
        targetAudience: 'enterprise',
        retention: 'newcontract',
        productType: 'credit',
        productLine: productLine,
        productCategory: productCategory,
        units: amount
    };

    oOrder.aPropositions.push(aPropositions);

    const priceMonthly = Math.round( (offer.getMonthlyPrice() - offer.getMonthlyOptionsSum()) * amount * 100) / 100;

    const tariffTrackProduct = {
        sku: tariff.getVluxId() ? tariff.getVluxId() + '' : tariff.id + '',
        name: entityDecode(tariff.label),
        type: 'tariff',
        priceOnce: '0.00',
        priceMonthly: priceMonthly.toFixed(2),
        duration: offer.getMinimumTerm(),
        proposition: 1,
        units: amount
    };

    oOrder.aProducts.push(tariffTrackProduct);

    if (product) {
        const priceOnce = offer.getOnetimePrice();
        const productTrackProduct = {
            sku: product.getSAPId() + '',
            name: `${product.getLabel()} ${product.getCurrentColor()} ${product.getCurrentCapacity()}`.replace(/[^a-zA-Z0-9 \- ]/g, ""),
            type: 'device',
            priceOnce: priceOnce.toFixed(2) + '',
            priceMonthly: '0.00',
            duration: offer.getMinimumTerm(),
            proposition: 1,
            units: amount
        };
        oOrder.aProducts.push(productTrackProduct);
    }

    const usedOptions = offer.getUsedOptions();

    usedOptions.forEach(option => {

        let optionId: number = option.id;

        if (option.description.backendId) {
            if (option.description.backendId[0].system === "VLUX") {
                optionId = option.description.backendId[0].value;
            }
        }

        const type = option.prices[0].value < 0 ? 'discount' : 'service';

        oOrder.aProducts.push({
            name: 'Business ' + entityDecode(option.description.label) + '',
            priceMonthly : option.prices[0].value.toFixed(2) + '',
            type : type,
            sku: optionId + '',
            proposition : 1
        });

    });

    return oOrder;
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/services/tracking/get-o-order.ts